// Reuse the server's LLM client after validating the current ai-token account.
import { apiJSON, jsonBody } from './http'

export async function complete(messages, options = {}) {
  const body = { messages }
  if (options.temperature != null) body.temperature = options.temperature
  const data = await apiJSON('/api/topology/complete', { ...jsonBody('POST', body), timeoutMs: 130000 })
  if (typeof data.content !== 'string' || !data.content.trim()) throw new Error('模型响应未包含文本。')
  return data.content
}
